import { render, staticRenderFns } from "./safe-userList.vue?vue&type=template&id=072a0edf&scoped=true&"
import script from "./safe-userList.vue?vue&type=script&lang=js&"
export * from "./safe-userList.vue?vue&type=script&lang=js&"
import style0 from "./safe-userList.vue?vue&type=style&index=0&id=072a0edf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072a0edf",
  null
  
)

export default component.exports